import React, { useEffect, useState } from "react";
import { Input, Switch, Divider } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useProjectState } from "../../../../context/stateContext";
import "./index.css";

const EditTabsOrderingSettings = ({ sendOrderingState, organization }) => {
  const [orderingEnabled, setOrderingEnabled] = useState(null);
  const [paymentsEnabled, setPaymentsEnabled] = useState(null);
  const [notifyWaiterEnabled, setNotifyWaiterEnabled] = useState(null);
  const [autoAcceptOrderEnabled, setAutoAcceptOrderEnabled] = useState(null);
  const [showNotifyWaiterButton, setShowNotifyWaiterButton] = useState(null);
  const [takeawayOptionEnabled, setТakeawayOptionEnabledn] = useState(null);
  const [externalCategoriesUrl, setExternalCategoriesUrl] = useState(null);
  const [defaultPriceListIds, setDefaultPriceListIds] = useState(null);
  const { openEditOrganizationModal } = useProjectState();

  const OrderingState = {
    orderingEnabled,
    paymentsEnabled,
    notifyWaiterEnabled,
    autoAcceptOrderEnabled,
    showNotifyWaiterButton,
    takeawayOptionEnabled,
    externalCategoriesUrl,
    // Add values in [int, int, int] format
    defaultPriceListIds:
      defaultPriceListIds === null || defaultPriceListIds === ""
        ? null
        : defaultPriceListIds
            ?.split(",")
            ?.map((item) => item.trim())
            ?.filter((item) => item !== "")
            ?.map((item) => parseInt(item, 10))
            ?.filter((item) => !isNaN(item)),
  };

  useEffect(() => {
    sendOrderingState(OrderingState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(OrderingState)]);

  useEffect(() => {
    setOrderingEnabled(
      organization?.myMenuConfiguration?.orderingConfiguration?.orderingEnabled
    );
    setPaymentsEnabled(
      organization?.myMenuConfiguration?.orderingConfiguration?.paymentsEnabled
    );
    setNotifyWaiterEnabled(
      organization?.myMenuConfiguration?.orderingConfiguration
        ?.notifyWaiterEnabled
    );
    setAutoAcceptOrderEnabled(
      organization?.myMenuConfiguration?.orderingConfiguration
        ?.autoAcceptOrderEnabled
    );
    setShowNotifyWaiterButton(
      organization?.myMenuConfiguration?.orderingConfiguration
        ?.showNotifyWaiterButton
    );
    setТakeawayOptionEnabledn(
      organization?.myMenuConfiguration?.orderingConfiguration
        ?.takeawayOptionEnabled
    );
    setExternalCategoriesUrl(
      organization?.myMenuConfiguration?.orderingConfiguration
        ?.externalCategoriesUrl
    );

    const defaultPriceListIds =
      organization?.myMenuConfiguration?.orderingConfiguration
        ?.defaultPriceListIds;

    setDefaultPriceListIds(
      defaultPriceListIds ? defaultPriceListIds.join(", ") : null
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, openEditOrganizationModal]);

  const handleInputChange = (e) => {
    setDefaultPriceListIds(e.target.value);
  };

  return (
    <>
      <div className="admin-organization-edit-sections">
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Поръчка
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={orderingEnabled}
            onChange={(value) => setOrderingEnabled(value)}
          />
        </div>
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Плащания
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={paymentsEnabled}
            onChange={(value) => setPaymentsEnabled(value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Повикване на сервитьор
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={notifyWaiterEnabled}
            onChange={(value) => setNotifyWaiterEnabled(value)}
          />
        </div>
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Покажи бутон сервитьор
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={showNotifyWaiterButton}
            onChange={(value) => setShowNotifyWaiterButton(value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Приемане без потвърждение
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={autoAcceptOrderEnabled}
            onChange={(value) => setAutoAcceptOrderEnabled(value)}
          />
        </div>
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Вземи за вкъщи
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={takeawayOptionEnabled}
            onChange={(value) => setТakeawayOptionEnabledn(value)}
          />
        </div>
      </div>
      <Divider></Divider>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-ordering-external-categories-container">
          <label className="admin-organization-edit-input-label">
            ExternalCategoriesUrl
          </label>
          <Input
            value={externalCategoriesUrl}
            onChange={(e) => setExternalCategoriesUrl(e.target.value)}
          />
        </div>
      </div>
      <div className="admin-organization-edit-sections">
        <div className="admin-organization-edit-ordering-external-categories-container">
          <label className="admin-organization-edit-input-label">
            Ценова листа
          </label>
          <Input
            value={defaultPriceListIds}
            onChange={handleInputChange}
            placeholder="1, 2, 3"
          />
        </div>
      </div>
      <Divider />
    </>
  );
};

export default EditTabsOrderingSettings;
